import { PromotionIntent } from '../../types/cart'

export type ValidatedPromotionCode = {
  code: string
  cartKey: string
}

/**
 * Build the promotion intent that is safe to submit with a reservation.
 *
 * A code is included only when the promotion check that accepted it still belongs to the
 * exact value currently in the field. This equality check is intentionally repeated at
 * the submission boundary: React effects clear stale validation state after a render, so
 * relying on that state alone leaves a small edit-and-continue window for an old code.
 */
export const promotionReservationIntent = (
  draft: PromotionIntent,
  cartKey: string,
  validated?: ValidatedPromotionCode
): PromotionIntent => {
  const currentCode = (draft.code ?? '').trim()

  return validated !== undefined &&
    validated.code === currentCode &&
    validated.cartKey === cartKey
    ? { applyAutomatic: draft.applyAutomatic, code: validated.code }
    : { applyAutomatic: draft.applyAutomatic }
}
